<template>
  <div>
    <v-dialog v-model="dialog" max-width="480" persistent overlay-opacity="0.7">
      <v-card class="rounded-lg">
        <v-card-title class="d-flex align-center pa-6 pb-4">
          <v-icon large :color="iconColor" class="mr-3">
            {{ icon }}
          </v-icon>
          <div>
            <h3 class="text-h6 font-weight-bold mb-0">
              {{ titulo }}
            </h3>
          </div>
        </v-card-title>

        <v-card-text class="px-6 py-0">
          <div class="text-body-1 mb-4">
            <p class="mb-3">
              Tem certeza que deseja <strong>{{ acao }}</strong
              >?
            </p>
            <v-alert v-if="avisoTexto" :type="avisoTipo" outlined dense class="mb-0">
              <div class="d-flex align-start">
                <div class="text-caption">
                  {{ avisoTexto }}
                </div>
              </div>
            </v-alert>
          </div>
        </v-card-text>

        <v-card-actions class="px-6 py-4">
          <v-spacer></v-spacer>

          <v-btn text color="grey darken-1" class="mr-2" @click="cancelar" :disabled="loading">
            <v-icon left small>mdi-close</v-icon>
            {{ textoCancelar }}
          </v-btn>

          <v-btn
            :color="corBotaoConfirmar"
            depressed
            class="font-weight-medium"
            @click="confirmar"
            :loading="loading"
            :disabled="loading"
          >
            <v-icon left small>{{ iconeBotaoConfirmar }}</v-icon>
            {{ textoConfirmar }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "EModalConfirmacao",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    titulo: {
      type: String,
      default: "Confirmar Ação",
    },
    acao: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: "mdi-help-circle-outline",
    },
    iconColor: {
      type: String,
      default: "warning",
    },
    textoConfirmar: {
      type: String,
      default: "Sim, Confirmar",
    },
    textoCancelar: {
      type: String,
      default: "Cancelar",
    },
    corBotaoConfirmar: {
      type: String,
      default: "success",
    },
    iconeBotaoConfirmar: {
      type: String,
      default: "mdi-check-circle",
    },
    avisoTexto: {
      type: String,
      default: null,
    },
    avisoTipo: {
      type: String,
      default: "info",
    },
    avisoIcon: {
      type: String,
      default: "mdi-information",
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  methods: {
    confirmar() {
      this.$emit("confirmado");
      this.dialog = false;
    },

    cancelar() {
      this.dialog = false;
    },

    setLoading(status) {
      this.loading = status;
    },
  },
};
</script>
